/**
 * Reserve de place au bas de la page, pour que le bouton d'export flottant ne
 * recouvre pas la fin du tableau.
 *
 * LE PROBLEME. Le bouton flottant est en `position: fixed`, au coin bas-droite. Il
 * masque donc les dernieres lignes du tableau et sa pagination, et aucun
 * defilement ne les degage : le bouton suit l'ecran.
 *
 * CE QUI SE FAISAIT. `marginBottom: 80` sur la carte du tableau, ecran par ecran.
 * Cinq l'avaient, douze l'avaient oubliee - et chacun avec une structure
 * differente : une carte ici, un tableau nu la, deux boutons ailleurs. Une regle a
 * recopier a douze endroits est une regle qu'on oublie au treizieme.
 *
 * CE QUI SE FAIT. Le bouton pose lui-meme la reserve, le temps qu'il est monte, en
 * ecrivant la variable CSS que `Layout` lit pour le bas de sa zone de contenu. Une
 * variable CSS et non une classe : le `<main>` porte son padding en style inline,
 * qui gagnerait contre toute regle de feuille de style.
 *
 * POURQUOI UN COMPTEUR. Un ecran peut porter deux boutons flottants - « Relances »
 * en a deux. Sans comptage, le demontage du premier libererait la reserve alors que
 * le second en a encore besoin.
 */
export const VARIABLE_RESERVE = '--cb-reserve-bas';

/**
 * @param porte  l'objet de styles qui porte la variable - en pratique
 *               `document.documentElement.style`. Injecte pour etre verifiable.
 * @param hauteur la reserve a poser, en CSS.
 */
export function creerReserveBasPage(porte, hauteur) {
  let compteur = 0;

  return {
    /** Pose la reserve si besoin, et rend la fonction qui la relache. */
    reserver() {
      compteur += 1;
      if (compteur === 1 && porte) porte.setProperty(VARIABLE_RESERVE, hauteur);

      let relache = false;
      return () => {
        /* Un nettoyage d'effet peut etre rappele. Sans ce verrou, le compteur
           descendrait sous zero et libererait la reserve d'un bouton encore
           monte. */
        if (relache) return;
        relache = true;
        compteur -= 1;
        if (compteur === 0 && porte) porte.removeProperty(VARIABLE_RESERVE);
      };
    },
  };
}

/**
 * La reserve de l'application : une seule, partagee par tous les boutons.
 *
 * 112 px = les 32 px de marge du bouton, sa hauteur en taille `large`, et de quoi
 * respirer sous la pagination.
 */
export const reserveBasPage = creerReserveBasPage(
  typeof document !== 'undefined' ? document.documentElement.style : null,
  '112px',
);
